module.exports = __webpack_public_path__ + "img/MNEX22-default-front.16a507a6.jpg";